package games.polyclub.frontend.store.shared

import kotlinx.serialization.Serializable

@Serializable
data class RegisterResponse(
    val errorMessage: String? = null,
    val autoLogin: LoginResponse? = null,
)
